export const host = 'https://api.www.gts56.com:5001'
// export const host = 'http://192.168.1.117:1212'